import {InputWrapper} from '@mantine/core';
import classes from './input-wrapper.module.css';

export const InputWrapperTheme = InputWrapper.extend({
  classNames: {
    label: classes.label,
  },
});